<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>Shift Allocation</h5>
            </div>
            <div class="basic-contbox">
                <label nz-checkbox [(ngModel)]="checked">Show data with Previous Attendance Shift</label>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Main Department</h5>
                    </div>
                    <div class="emp-input">
                        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Department" [(ngModel)]="selectedValue">
                            <nz-option nzLabel="Jack" nzValue="jack"></nz-option>
                            <nz-option nzLabel="Lucy" nzValue="lucy"></nz-option>
                            <nz-option nzLabel="Tom" nzValue="tom"></nz-option>
                          </nz-select>
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Department</h5>
                    </div>
                    <div class="emp-input">
                        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Department" [(ngModel)]="selectedValue">
                            <nz-option nzLabel="Jack" nzValue="jack"></nz-option>
                            <nz-option nzLabel="Lucy" nzValue="lucy"></nz-option>
                            <nz-option nzLabel="Tom" nzValue="tom"></nz-option>
                        </nz-select>
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Punch ID</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Punch ID" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Month Year</h5>
                    </div>
                    <div class="emp-input">
                        <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                    </div>
                </div>

                <div class="grace-btnbox">
                    <ul>
                        <li><a href="javascript:void();"><span></span> Edit</a></li>
                        <li><a href="javascript:void();"><span></span> Save</a></li>
                        <li><a href="javascript:void();"><span></span> Clear</a></li>
                        <li><a href="javascript:void();"><span></span>Close</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="basic-details basic-details3">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Main Department</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Emp code</th>
                            <th>Punch Id</th>
                            <th>Employee</th>
                            <th>Desig Name</th>
                            <th>Default Shift</th>
                            <th>1</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>